import { Integration, SDK, SDKResponse } from "@commercetools/frontend-sdk";
import { getProductActions, ProductActions } from "./actions/ProductActions";
import { getCartActions, CartActions } from "./actions/CartActions";
import { getWishlistActions, WishlistActions } from "./actions/WishlistActions";
import { AccountActions, getAccountActions } from "./actions/AccountActions";
import { ComposableCommerceEventsB2B } from "../types/events/ComposableCommerceEventsB2B";
import { ProjectActions, getProjectActions } from "./actions/ProjectActions";
import { QuoteActions, getQuoteActions } from "./actions/QuoteActions";
import { getProjectBuilderAction, ProjectBuilderActions } from "./actions/ProjectBuilderAction";
import { CheckoutCartActions, getCheckoutCartActions } from "./actions/CheckoutCartActions";
import {
	BusinessUnitActions,
	getBusinessUnitActions,
} from "./actions/BusinessUnitActions";
import { CustomActions, getCustomActions } from "./actions/CustomActions";
import { CheckoutReviewActions, getCheckoutReviewActions } from "./actions/CheckoutReviewActions";
import { PaymentActions, getPaymentActions } from "./actions/PaymentActions";

type CommercetoolsSdk<T> = SDK<ComposableCommerceEventsB2B> & {
	call: <T>(arg: any) => Promise<{ data?: T, isError: boolean, statusCode?: number, error?: object | string }>;
	callActionWrapper: <T>(arg: any) => Promise<SDKResponse<T>>;
};

class ComposableCommerceB2B extends Integration<ComposableCommerceEventsB2B> {
	constructor(sdk: CommercetoolsSdk<ComposableCommerceEventsB2B>) {
		super(sdk);

		this.account = getAccountActions(sdk);
		this.businessUnit = getBusinessUnitActions(sdk);
		this.cart = getCartActions(sdk);
		this.product = getProductActions(sdk);
		this.project = getProjectActions(sdk);
		this.projectBuilder = getProjectBuilderAction(sdk);
		this.quote = getQuoteActions(sdk);
		this.wishlist = getWishlistActions(sdk);
		this.custom = getCustomActions(sdk);
		this.payment = getPaymentActions(sdk);
		this.checkoutCart = getCheckoutCartActions(sdk);
		this.checkoutReview = getCheckoutReviewActions(sdk);
	}

	unregisterExtension(): void {}

	account: AccountActions;
	businessUnit: BusinessUnitActions;
	cart: CartActions;
	product: ProductActions;
	project: ProjectActions;
	projectBuilder: ProjectBuilderActions;
	quote: QuoteActions;
	wishlist: WishlistActions;
	custom: CustomActions;
	checkoutCart: CheckoutCartActions;
	checkoutReview: CheckoutReviewActions;
	payment: PaymentActions;
}

export { ComposableCommerceB2B, type CommercetoolsSdk };
